<script>
  export default {
    name: 'BannerPreview',
    props: {
      // 预览标题
      title: {
        type: String,
        default: 'banner 位样式预览'
      },
      showTitle: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<template>
  <div class="banner-preview">
    <div class="preview-title" v-if="showTitle">{{ title }}：</div>
    <div class="preview-container">
      <!-- 图片插槽 -->
      <slot name="imgSlot"></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .banner-preview {
    width: 100%;
    display: flex;

    .preview-title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }

    .preview-container {
      position: relative;

      .phone-frame {
        width: 280px;
        height: 560px;
        border: 10px solid #e0e0e0;
        border-radius: 30px;
        overflow: hidden;
        background-color: #fff;
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        margin: 0 auto;
        display: flex;
        flex-direction: column;

        .phone-header {
          height: 40px;
          background-color: #f5f5f5;
          position: relative;

          .phone-camera {
            position: absolute;
            width: 15px;
            height: 15px;
            border-radius: 50%;
            background-color: #333;
            top: 12px;
            left: 50%;
            transform: translateX(-50%);
          }
        }

        .phone-content {
          flex: 1;
          overflow-y: auto;
          background-color: #f8f8f8;

          .empty-preview {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #909399;

            i {
              font-size: 48px;
              margin-bottom: 10px;
            }

            p {
              margin: 0;
            }
          }
        }

        .phone-footer {
          height: 40px;
          background-color: #f5f5f5;
          display: flex;
          justify-content: center;
          align-items: center;

          .phone-home-button {
            width: 40px;
            height: 4px;
            background-color: #d0d0d0;
            border-radius: 2px;
          }
        }
      }
    }
  }
</style>
